// extracted by mini-css-extract-plugin
export default {"clanName":"InGroupClanRatingTable_clanName_afe6c","thead":"InGroupClanRatingTable_thead_bf581","tbody":"InGroupClanRatingTable_tbody_b93db"};